var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Cloud/24/Gear",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.64 3.75c.558 0 1.081.451 1.167.985l.216 1.35a6.243 6.243 0 012.086 1.206l1.278-.489c.514-.197 1.154.03 1.436.517l.642 1.112c.278.482.15 1.161-.27 1.502l-1.061.862a6.281 6.281 0 010 2.41l1.06.862c.428.347.552 1.014.27 1.502l-.641 1.112c-.279.482-.931.71-1.436.517l-1.278-.489a6.243 6.243 0 01-2.086 1.206l-.216 1.35c-.088.544-.603.985-1.166.985h-1.284c-.557 0-1.08-.451-1.166-.985l-.216-1.35a6.243 6.243 0 01-2.084-1.206l-1.28.489c-.515.197-1.154-.03-1.436-.517l-.642-1.112c-.278-.482-.15-1.161.27-1.502l1.063-.863a6.282 6.282 0 010-2.408l-1.063-.863c-.427-.347-.551-1.014-.27-1.502l.642-1.112c.279-.482.93-.71 1.436-.517l1.28.489a6.243 6.243 0 012.084-1.206l.216-1.35c.087-.544.603-.985 1.166-.985h1.284zm-.64 5a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5z",
    id: "Combined-Shape",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear24);
export default __webpack_public_path__ + "static/media/gear-24.f122c84d.svg";
export { ForwardRef as ReactComponent };